import React from 'react';
import Link from 'next/link';
import { useAccaTestResultStore } from '@stores/AccaTestResultStore';
import { AccaRouteUrl, V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const AccaItem = ({ isResult }: { isResult: boolean }) => {
  const handleResultExampleClick = () => {
    window.open(AccaRouteUrl.ACCA_SAMPLE_RESULT, '_blank', 'menubar=no, toolbar=no, width=1040');
  };

  if (!isResult) {
    return (
      <div className={cx('linkItem')}>
        <div className={cx('title')}>
          역검 결과표
          <br />
          100% 활용하기
        </div>
        <button className={cx('link')} onClick={handleResultExampleClick}>
          결과표 예시
        </button>
      </div>
    );
  }

  return (
    <div className={cx('linkItem')}>
      <div className={cx('title')}>
        역검 결과표
        <br />
        100% 활용하기
      </div>
      <Link href={V2Route.getAccaUsagePage()} legacyBehavior>
        <a className={cx('link')}>
          <span className={cx('text')}>확인하기</span>
        </a>
      </Link>
    </div>
  );
};

const LinkList = () => {
  const accResults = useAccaTestResultStore((state) => state.accResults);
  const isResult = !!accResults?.resultRecords?.length || 0 > 0 || false;

  return <AccaItem isResult={isResult} />;
};

export default LinkList;
